import InsightCountOptionsSchema, {
  InsightCountOptions
} from '../../schemas/action/InsightCountOptionsSchema'

export default function InsightCountOptionsVo(initData: unknown = {}): InsightCountOptions {
  return InsightCountOptionsSchema.validateSync(initData)
}
